/* eslint-disable no-param-reassign */

import { createAsyncThunk, createSlice, SerializedError } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import { AppDispatch } from '.'
import { ApplicationResponse, getApplication, deleteApplication as apiDeleteApplication } from '../api/registration'
import { RootState } from './rootReducer'

interface State {
  application: ApplicationResponse | null
  loading: 'idle' | 'pending'
  error: SerializedError | null
}

const initialState: State = {
  application: null,
  loading: 'idle',
  error: null,
}

export const fetchApplication = createAsyncThunk<
  ApplicationResponse,
  string,
  {
    state: RootState
    dispatch: AppDispatch
  }
>('application/fetchApplication', async (id) => {
  const response = await getApplication(id)
  return response.data
})

export const deleteApplication = createAsyncThunk<
  AxiosResponse,
  string,
  {
    state: RootState
  }
>('application/deleteApplication', async (id) => {
  const response = await apiDeleteApplication(id)
  return response
})

const slice = createSlice({
  name: 'application',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    /*
     * fetchApplication
     */
    builder.addCase(fetchApplication.pending, (state) => {
      state.application = null
      state.error = null
      state.loading = 'pending'
    })
    builder.addCase(fetchApplication.fulfilled, (state, { payload }) => {
      state.application = payload
      state.loading = 'idle'
    })
    builder.addCase(fetchApplication.rejected, (state, action) => {
      state.error = action.error
      state.loading = 'idle'
    })

    /*
     * deleteApplication
     */
    builder.addCase(deleteApplication.pending, (state) => {
      state.loading = 'pending'
    })
    builder.addCase(deleteApplication.fulfilled, (state) => {
      state.application = null
      state.error = null
      state.loading = 'idle'
    })
    builder.addCase(deleteApplication.rejected, (state, action) => {
      state.loading = 'idle'
    })
  },
})

// export const { } = slice.actions

export default slice.reducer
